import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/gcstudent/selectlogin/SelectLoginPage.css";
import AppContext from "../../../context/AppContext";

/* ══════════════════════════════════════════════
   Select Login Page
   ✅ login check AppContext (loggedInUser + userType) se
   ✅ authLoading khatam hone ka wait karte hain warna
      refresh/redirect ke waqt galat time pe check ho sakta hai
   ✅ Student login: koi state pass nahi — StudentLoginPage khud
      pendingReservation localStorage se check karta hai (original)
   ✅ Teacher login: redirectTo state se bhi bhej sakte hain, lekin
      TeacherLoginPage bhi khud pendingReservation check karta hai
══════════════════════════════════════════════ */
const SelectLoginPage = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  const { loggedInUser, userType, authLoading } = useContext(AppContext);

  useEffect(() => {
    if (authLoading) return; // auto-login abhi verify ho raha hai — wait karo

    if (loggedInUser?.id && (userType === "student" || userType === "teacher")) {
      navigate("/confirm-reservation");
      return;
    }

    setTimeout(() => setVisible(true), 60);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedInUser, userType, authLoading]);

  const handleStudentLogin = () => {
    navigate("/student/login");
  };

  const handleTeacherLogin = () => {
    navigate("/teacher/login", { state: { redirectTo: "/confirm-reservation" } });
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className={`sl-page ${visible ? "sl-page--in" : ""}`}>
      <div className="sl-card">
        <div className="sl-icon-wrap">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="1.8"/>
            <path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
            <circle cx="12" cy="16" r="1.2" fill="currentColor"/>
          </svg>
        </div>

        <h2 className="sl-heading">Login Required</h2>
        <p className="sl-subtext">Log in first to reserve a book.</p>

        <div className="sl-divider">
          <span>Select your role</span>
        </div>

        <div className="sl-buttons">
          <button className="sl-btn sl-btn--student" onClick={handleStudentLogin}>
            <div className="sl-btn__icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="1.8"/>
              </svg>
            </div>
            <div className="sl-btn__text">
              <span className="sl-btn__title">Login as Student</span>
            </div>
            <svg className="sl-btn__arrow" width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>

          <button className="sl-btn sl-btn--teacher" onClick={handleTeacherLogin}>
            <div className="sl-btn__icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="1.8"/>
                <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
              </svg>
            </div>
            <div className="sl-btn__text">
              <span className="sl-btn__title">Login as Teacher</span>
            </div>
            <svg className="sl-btn__arrow" width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <button className="sl-back" onClick={handleBack}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M19 12H5M5 12l7 7M5 12l7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          Back to Library Page
        </button>
      </div>
    </div>
  );
};

export default SelectLoginPage;